import * as React from 'react';
import { SiteAdminSettingsView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';
import { IRoute } from 'lib/componentRouter';

export const SiteAdminSettingsRoute = (appWrapper : AppWrapper) : IRoute => ({
    view:
        <AppWrapperView model={appWrapper}>
            <SiteAdminSettingsView />
        </AppWrapperView>
});


// WEBPACK FOOTER //
// ./apps/portcall/siteadminsettings/route.tsx